"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AUSTRIA_STATE_BBOX = exports.AUSTRIA_DISTRICTS = void 0;
// GENERATED by scripts/build-austria-districts.mjs - do not edit by hand.
// Austrian politische Bezirke (+ Wiener Gemeindebezirke) as SVG paths, in the
// projection of austria-map.ts (viewBox 0 0 1000 517).
// Geometry: CC BY 4.0 Flooh Perlot (github.com/ginseng666/GeoJSON-TopoJSON-Austria),
// based on CC BY 4.0 Statistik Austria - data.statistik.gv.at (borders 2021,
// simplified 99.9 %). See documentation/charts-map.md.
const federal_state_1 = require("./federal-state");
/** All Bezirke, per Bundesland the large ones first (paint order). */
exports.AUSTRIA_DISTRICTS = [
    {
        code: "107",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Neusiedl am See",
        d: "M966 262.5l-11.3 0.5-0.6-6-5 7.4-10.2 0.3-1.2-2.7-2.4-7.6 0.4-9 1-5.3 0.5-2.7 4-8.5 2.2-3.1 0.9-1.1 0.7-1.1 1-1.3-10.5-11.4-2.8-2.3 0.2-7.2 15.8-3.4 0.4 0 5.9-8.2 3.9 0.2 1.4 2.7 7 5.9 3.2-3.7 2.9-5.4-2.3-2-3.6-3.2 2-2 1.5 0.4 1.2 3.4 3.7 1.4 4-6.6 0.4 11.8 0.7 5.6 4.5-0.7 6.5 4.8-8.5 6.8 2.9 1.9-1.7 11.8-3.4 4.2-8.6 3.8 4.6 5.6 3.1 15.1 0.1 8.3-4 0.4-10.5 2.2z",
        label: [956.2, 238.5],
        bbox: [932.7, 180.9, 992, 264.7],
    },
    {
        code: "109",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Oberwart",
        d: "M896.6 357.5l4.2 1.7 0.1 8.8-1 2.8-6.5-0.4-0.3-1.1-9.7-3.3 1.2-4.9-6.6-3.7-5-2.8-1.3-0.2-4.4-0.1-2.2 2.7-3.3-0.2-3.3-5.3-3.6-1-1.4 0-1.3-7.3-0.3-0.6-2-6.7 0.1-0.9-3.2-7.9-0.6-3 0.5-0.1-0.5-1.4 3.7-0.9 0.2 0 3.1-4.8 4.1-0.9 3.3-0.7 3-0.6 0.9-0.4 4.5-0.4 6-4.5 3.6-1.3 4.3 9.6 4.6 1.9 2.4 8.1 1.1 1.2 0.9 0.3 6.4-1.5 3.7 3.2 2 11.7-6.2 4.7-1.7 8.6 0.5 1.6z",
        label: [870.3, 334.2],
        bbox: [846.2, 308.1, 904, 370.8],
    },
    {
        code: "108",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Oberpullendorf",
        d: "M901.5 316.1l-0.3 8.8-2.9 2.8-6.4 1.5-0.9-0.3-1.1-1.2-2.4-8.1-4.6-1.9-4.3-9.6 5.1-7.4 2.4-4.3-3-5.1-0.3 0-0.1-4.4 2.3-4.6 1.7-2.5 3.7-7.7 0.9 1.4 3.9-2.7 1.5-2.9 3.7 1.7 6.1 3.2 2.4-1.2 9.5 5.3 8.1-0.9 1.3 10.3 5.5 8.7-6.9 4.4 1.3 8.5-6.5 4.7-3.1 1.7-1.5 3.1-15.1-1.3z",
        label: [906, 293.4],
        bbox: [878.6, 267.9, 933.3, 329.2],
    },
    {
        code: "103",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Eisenstadt-Umgebung",
        d: "M918.5 250l-6.2 3-0.7 0.5-2.1-0.9-3-3.7 0.9-2.9-5.1-1.8-2.3-2.9-1.1 0.6-0.8 0-3.8 0.3-5.3-4.7 2-0.8-0.4-4.8-3.4-3 4.5-1.6 0.8-1 4.3-3.9 3.9-6.2 8.5-1.8 2.9 4.6 4.2 6.4 0.8-0.4 2.2-3 1.5-1.6 3-4 0-0.1 1-2.3 3.3-2.2 4.6-3.2 2.8 2.3 10.5 11.4-1 1.3-0.7 1.1-0.9 1.1-2.2 3.1-4 8.5-0.5 2.7-10.5-2.7-1.1 0.9 2.9 6 7.7 1.1-0.4 9-8.2-1.3-3-3.3-1.5 0.4-4.1-0.2zM904.7 228.7l2.6 10.3 3.5 4.2 2-0.1 4.4-8.7-1.8-8.5-5.2 1.7-5.5 1.1z",
        label: [930.1, 226.7],
        bbox: [887.2, 208.6, 946, 254.4],
    },
    {
        code: "104",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Güssing",
        d: "M883.9 394.8l-2.6 0.8-0.5-1.5-1.2-1.4-0.1-0.8-7.1-0.4 1.3-4.6-2-0.9-4.6 0.7-3.6 1.4-4.6-7.4 3.5-5.1-2.3-5.4-3-0.4-0.7-6.5-0.9-3.2-1.4-2.9 0.2-0.2-0.8-6.5 1.4 0 3.6 1 3.3 5.3 3.3 0.2 2.2-2.7 4.4 0.1 1.3 0.2 5 2.8 6.6 3.7-1.2 4.9 9.7 3.3 0.3 1.1 6.5 0.4 1-2.8 5.9 3.6-4.6 4.7 3 5.8-4.7 5.5 5.3 5.7-8.4 3.3-5.2-1.4-5.7 0.3-2.6-0.7z",
        label: [887.9, 382.2],
        bbox: [853.5, 350.5, 906.8, 396.6],
    },
    {
        code: "105",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Jennersdorf",
        d: "M850.8 424.1l-9 2.7 0.9-2.2 2.6-7.8 1.6-1 2.4-3.3 5.2-4.6 0.1-3.8 1.6-2.2 6-4.8-1.1-1.8-1.9-2.3-4.2-9.4-1.5-5.1 1-4.7 2.6-4 3 0.4 2.3 5.4-3.5 5.1 4.6 7.4 3.6-1.4 4.6-0.7 2 0.9-1.3 4.6 7.1 0.4 0.1 0.8-4.4 9.5-5.8 4.1-1.6 0.5-2.4 6.4-11.2 8.1-3.4 2.8z",
        label: [869.4, 398.3],
        bbox: [841.8, 369.8, 879.6, 426.8],
    },
    {
        code: "106",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Mattersburg",
        d: "M896.7 267.8l0 0.1-1.5 2.9-3.9 2.7-0.9-1.4-2.1-7.1-4.2-0.7-1.9-0.7 0-1.6-1.8-3.8 0-5.2 0.5-3.6-0.1-0.1-3.8-5.6 2.2-4 3.8 5.2 5.1-6.9 0.9-0.5 5.3 4.7 3.8-0.3 0.8 0 1.1-0.6 2.3 2.9 5.1 1.8-0.9 2.9 3 3.7 2.1 0.9-0.1 0.6-5 6.4-6.5 1.3-3.3 6z",
        label: [892.1, 253.3],
        bbox: [877, 237.5, 911.6, 273.5],
    },
    {
        code: "101",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Eisenstadt (Stadt)",
        d: "M912.8 243.1l4.4-8.7-1.8-8.5-5.2 1.7-5.5 1.1 2.6 10.3 3.5 4.2 2-0.1z",
        label: [911.5, 233.5],
        bbox: [904.7, 225.9, 917.2, 243.2],
    },
    {
        code: "102",
        state: federal_state_1.FederalState.BURGENLAND,
        name: "Rust (Stadt)",
        d: "M936.7 240.1l-10.5-2.7-1.1 0.9 2.9 6 7.7 1.1 1-5.3z",
        label: [930.2, 241.6],
        bbox: [925.1, 237.4, 936.7, 245.4],
    },
    {
        code: "206",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Spittal an der Drau",
        d: "M509.9 447.2l2 9.2-0.7 4.6-9.3-2.9-17-7.6-5.3 3.5-6.2 1.8-2.6-0.1-4.5-3.1-2.8-0.1-8.6-1.7-5.4-2.9-8.4 1.4-6.2-6 2-2 5.5-3.2 4.2 2.4 4.1-6.6-7.3-4.6-0.2 0-1.2-0.6-7.1-6.8-2.5-10.7-1.7-1.1-1.9-0.7-0.9-2.5-3.5-3.3-2.4-2.4 1.8-10.7-5.7-4.5-6.9-9.8 1.2-4.4 8.3-1.6 1 5.9 10.5 0.5 15.1 4.1 2.1 5.1 4.1 2.7 2.3-1.6 9 5.8 1-2.5 21.6-4.6 3.8-8.5 9.9-0.4 6.7 5.3 2.8-2.3 21.4 4.9 5.6 0.1 6.4 3 1.6 7 9.3 5 1.7 6.4 4 4.8-1.2 0-2.4 7.1 7.2 7.3-2 11.7-0.4 0.1-0.2 0-6.4-2.2-11.5 0.2-4.4 5-4-2-4.1 6.3-12.2-2.1-4.9-2.8-4.2 7.7z",
        label: [490.9, 417.5],
        bbox: [411.2, 370.2, 564.2, 461],
    },
    {
        code: "205",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Sankt Veit an der Glan",
        d: "M661 441l-2.3 5.7-5.2-1.8-5 10.5-3.9-0.3-0.3-5.5-5.9-2.9-3.5 2.8-4-1-8.5 5.1-2.8-2.2-5.4 2 0.3-0.6 2.4-7.9-6.7 0.5-0.5-9.1-4.6-1.3 1.7-0.9-8.5-2.5 3.6-8-0.2 0.1-3 3-10.5-2.4-4-3.1-0.8-8.7-5.9-5.8 2.8-4.3 6.2-5 8.1-6.3 6.9-7.8 3.7 2 5.3-4.6 4.2 9.7 0.3-0.5 12-0.2 12.9 5.5 5.3-1.4 14.7-0.7 3.8 2.6 9 8.2-0.1 0.7-4.9 12.3 0.6 8.6 0.2 3.2-0.7 4.5-1.7 9.9-5.1-2.1z",
        label: [631.1, 421.2],
        bbox: [577.5, 380.7, 672.7, 455.4],
    },
    {
        code: "207",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Villach Land",
        d: "M595.3 481.6l5.1 2.9-1.7 10.7-7.8-2.8-5.7 2.3-4-3.2-8.2-4.4-14.6 2.8-13.9-2.8-8.9-4-13.8-1.3-1.4-3.4 6.9-4.7-0.4-7.7 2.3-5-13.8 0.2-4.2-0.2 0.7-4.6-2-9.2 4.2-7.7 4.9 2.8 12.2 2.1 4.1-6.3 4 2 4.4-5 11.5-0.2 6.4 2.2 0.2 0 0.4-0.1 3.7 0.5 2.6 3.8 8.3 0.9 2.5 7.6-5.2 3.8 4.2 5.7-8 3.2-10.6-3.6-5.8 6.4-6.4 8.3 10.7 4.5 10.4-3.4 10.7 0.5 2.3-2-6-3.4-0.6-6.9 5.1-1.1 6-2.5 5 0.9 2.3 8.7-1.2 6.6 4.3 4.2-1.2 1.9z",
        label: [543.8, 453.7],
        bbox: [509.9, 434.9, 600.4, 495.2],
    },
    {
        code: "208",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Völkermarkt",
        d: "M682.3 490.3l-5.7 0.8-2.1 7-20.5 10-12-1.9-1.6-4.1 3.6-3.2 3.2-8.9-4.6-2.3 0.7-8.9 1.1-0.7 6.7-6 1.1-1.6-2.6-7.9-1.1-7.2 5-10.5 5.2 1.8 2.3-5.7 5.1 2.1 1.7-9.9 0.7-4.5 4.9 3.4 8.7 10 1.7 8.1 4.6 7.2 6.9-0.4-0.7 2 8.2 2.6 4.8 4.1-4.2 5.6-5.6-1.5-7.3 14.7-0.5 4.8-7.7 1z",
        label: [672.6, 470.1],
        bbox: [640.4, 428.7, 707.6, 508.1],
    },
    {
        code: "209",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Wolfsberg",
        d: "M718.8 448.8l-2.3 9.8 5.2 3.4-6.3 2.2-4.7 7.5-3.1-6-4.8-4.1-8.2-2.6 0.7-2-6.9 0.4-4.6-7.2-1.7-8.1-8.7-10-4.9-3.4-0.2-3.2-0.6-8.6 4.9-12.3 0.1-0.7-9-8.2 1.6-3 9.2-0.5 9.7-4.4 9.1-1.7 0.3 2.9 5 4.2 10.5 5.6 7.7 13.8-1.5 5.5-0.9 0.2 1.5 6.8-5.6 11.4 2.6 0.8 4.5 6.7 1.4 4.8z",
        label: [691.5, 418.2],
        bbox: [663.7, 386.1, 721.7, 471.7],
    },
    {
        code: "203",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Hermagor",
        d: "M515.4 461.2l13.8-0.2-2.3 5 0.4 7.7-6.9 4.7-10.4 1.5-6.6-4-6.4 5-9-1.4-10.8-5.4-10.5-2.4-2.2 0.4-4.9 0.6-12.7-2.6-5.6 0.5-7.3-0.5-7.5-7.1-5.7 2.4-5.3-4.4 2.7-15 4.7-2.3 6.2-1.5 1.8-0.2 4 1.3 6.2 6 8.4-1.4 5.4 2.9 8.6 1.7 2.8 0.1 4.5 3.1 2.6 0.1 6.2-1.8 5.3-3.5 17 7.6 9.3 2.9 4.2 0.2z",
        label: [491.3, 467.1],
        bbox: [415.5, 442, 529.2, 480.9],
    },
    {
        code: "204",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Klagenfurt Land",
        d: "M642.6 487.7l4.6 2.3-3.2 8.9-3.6 3.2-16.3 2.3-3.2-2.4-5.9 2.1-6-2.2-4.7 1.6-5.6-8.3 1.7-10.7-5.1-2.9 1.2-1.9-4.3-4.2 1.2-6.6-2.3-8.7 7.8-2.5 6-0.3 3.5-4.7 6.1 0.1-0.3 0.6-1.2 8.3 2.4 6.2-0.2 2.9 1.2 5.4 5.1 0.5 4.5-2.9 11.3-7.3 0.3-2.3-6.2-3.8-5.9-1.3-3.1-5.5 8.5-5.1 4 1 3.5-2.8 5.9 2.9 0.3 5.5 3.9 0.3 1.1 7.2 2.6 7.9-1.1 1.6-6.7 6-1.1 0.7-0.7 8.9z",
        label: [628, 490],
        bbox: [591.1, 446.7, 652.2, 504.4],
    },
    {
        code: "210",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Feldkirchen",
        d: "M586.1 459.3l-6 2.5-5.1 1.1 3.2-3.1 0.1-0.5-4.2-5.7 5.2-3.8-2.5-7.6-8.3-0.9-2.6-3.8-3.7-0.5 2-11.7-7.2-7.3 2.4-7.1 1.2 0 8.6 0.2 8.3-4.4 5.9 5.8 0.8 8.7 4 3.1 10.5 2.4 3-3 0.2-0.1-3.6 8 8.5 2.5-1.7 0.9 4.6 1.3 0.5 9.1 6.7-0.5-2.4 7.9-6.1-0.1-3.5 4.7-6 0.3-7.8 2.5-5-0.9z",
        label: [591.9, 444.2],
        bbox: [557, 406.7, 616.9, 462.9],
    },
    {
        code: "202",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Villach Stadt",
        d: "M581.6 473.2l-6-3.4-0.6-6.9 3.2-3.1 0.1-0.5-8 3.2-10.6-3.6-5.8 6.4-6.4 8.3 10.7 4.5 10.4-3.4 10.7 0.5 2.3-2z",
        label: [561.7, 468.5],
        bbox: [547.5, 458.9, 581.6, 478.1],
    },
    {
        code: "201",
        state: federal_state_1.FederalState.KAERNTEN,
        name: "Klagenfurt Stadt",
        d: "M616.4 476.2l5.1 0.5 4.5-2.9 11.3-7.3 0.3-2.3-6.2-3.8-5.9-1.3-3.1-5.5-2.8-2.2-5.4 2-1.2 8.3 2.4 6.2-0.2 2.9 1.2 5.4z",
        label: [622.7, 466.2],
        bbox: [613, 451.4, 637.6, 476.7],
    },
    {
        code: "319",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Sankt Pölten (Land)",
        d: "M769.1 211.8l-4.5 10.4-7.9 2.5-1.8-8.8-4.6-2-2.2-10.8 0.9-0.8 9.4-3.4 2.7-2.6 5.4-3.5 3.8-4.3 0.4-4.4 6-2.5 3.2-2.7 0.2-2-8.2-0.6 0.8-3-2-3.6-0.8-1.5-2.1-5 2-2.1 5.9-7.2 4.8-4.8 0.4-2.2-2.1-4.5 5.4-3.5 10.1 2.3 3.4-2.2 1.6-6 2.5-0.3 5.1-1.7 0.8-1 5.3 1.3 8 1.3-1.4 6.7-5.3-0.1-2.9 4.2 5.6 5.1 3.8 0 1.6 1.9-0.5 9 5.6-0.2 1-5.7 3.4-0.2 10.7 11.2 6.6-5.4 4.8-2 3.2-2.7 2.2-0.1 3.5-4.4 2.3-0.4 3.1 2.8 0.8 0.7-2.9 7.8 2.9 4-3.3 6-3.3 0.4-1 2.6-8.9 4.9-2.8-0.4-1.1-1.1-6.9-1.5-10.7 7.4 0.4 3.5-5.2 2.4-3.9 2.7-4.3-3-4.5 1.2-5.8-1.1-1.9-1.2-3.6-1-11.4 4.1-5.5-0.8-4.1 2.9 0.7 8.3 0.1 0.9-4.5 5.4-6.7 3.8-1.8 0.6zM787.6 162.9l-2.2 8.8 3.3 7.2 8 1.2-0.1-10.2 6.1-4 4-2.8 1.4-9 0.2-1.6-8.7 1-6.5 4.4-2.3 1.2-3.2 3.8z",
        label: [818.7, 173.4],
        bbox: [748.1, 130, 869.1, 224.7],
    },
    {
        code: "323",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Wiener Neustadt (Land)",
        d: "M875 309.4l-6 4.5-4.5 0.4-4.4-7.4 2.8-1.2 0.7-6.6-2.3-8.5 8.1 1.6-2.6-9.1-1.8-4.9 0.8-1.5 1.2-0.8 1.8-11.4 0.1-0.2-5.2-6.4 5.1-3.3-1.2-3.1 5.9-4.5 3.5-3.3 3.8 5.6 0.1 0.1-0.5 3.6 0 5.2 1.8 3.8 0 1.6 1.9 0.7 4.2 0.7 2.1 7.1-3.7 7.7-1.7 2.5-2.3 4.6 0.1 4.4 0.3 0 3 5.1-2.4 4.3-5.1 7.4-3.6 1.3zM866.9 240.6l-1.6 6.4-6.6-5.9-4.8 1.4-0.2-0.5-4.8-1.3-6.2-1.5-0.2-0.2-4 1.6-8.3-3.8-5.9 1.4-6.6 6.7-3.4-10.9-5.5-3.9-14.3 1.4-0.7-3.9 5.6-5.4 3 1.5 8.8-7.6 5.1-0.2 2.6-0.4 6.9-4.2 13.8 5.2 2.5-1.8-0.1 3.6 2.4-1.7-0.6 7.5 9.6-1.2 3.2 4.5 4.9-1.5 0.1-0.1 0-0.1 7-4 1.9 1.5 2.1-3.8 7.5 1.2-0.1 0.1 12.5 5.6-0.8 1-4.5 1.6 3.4 3 0.4 4.8-2 0.8-0.9 0.5-5.1 6.9-3.8-5.2-0.6-5.5-1.2-2.7-6.3-3.3-4 5.2-0.2 7.2z",
        label: [824.6, 226.3],
        bbox: [793.8, 211.3, 892.5, 314.3],
    },
    {
        code: "316",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Mistelbach",
        d: "M919.4 130.8l8.2 8-7.5 4.5-4.1-2.3-2.9-1-3 0.6-1.7-1.1-1.7-1.6-4.6-1.1-2.6-1.3-3.5-4.6 1.3-4 1.2-1.3 0.3-6.7-3.9-1.4 3.5-5.1-0.5-7.1-0.5 0-3 0.2 1.4-4-2.5-8-10-3.6-0.6 0.6-3.1 4.5 1.6-5.4-4.3-1.5-1.4-10-7.5-1.4 1.4-7.7 1.7-7.3 6.4-0.2 11.2 2.5 8.8-6.6 0.9-0.5 1.8-6.5 11-2.2 7.6 5.4 7.5-0.5 4 10.9 0 0.1 8.4-0.8 1.7 2.9 18.7 0.6 0.6 6.7 2.3 7.6-8.9 0.9-0.2 4.8-6-1.3-1.9-2.4-1.6-0.5-0.6-0.8-8.9 2.7-4.2-1.8-0.1 0.3 3.2 8.1-2.8 4.9-0.6 6.9-1.4 0.6-0.9 8-2.6 3-4 0-7.4-0.2 1.2 7 3 1.8 2 5.6 0.1 2.1z",
        label: [909.1, 75.9],
        bbox: [868, 48.2, 962, 143.3],
    },
    {
        code: "325",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Zwettl",
        d: "M731.4 137.5l-0.2 2.3-6.2-2.6-4.5-1.7-5.2-2.3-6.5-2.1-1.1-2.5-3.6-6.2-2.1-2.1-4.5-5.7 5.7-7.9-6-4.2-8.2-5 0.1-8.9 7.3-3.2 4.5-1 12.5-0.8 2.2-4.5-5.3-4.9 2.1-5.6 7.8 0.5 9.2-2 1.9 4.6 1.2-3.2 3.5-1 5.9-5.1 2.2-2.7 10.5-0.1 2.1-4.4 2.8 0.2 6-0.9 5.1 7-1 4 2.5 7.5-3.5 1.3-0.5 1.1 6.4 5.1 6.3-0.5 0.6 3-2.3 6.1-9.3-3.8-2.8 5.9-6.9 1.2-5.3-3.6-1.7 3.5 2.4 8.5-2.2 2 1.7 4.6-4.6 6.8 3.4 0.6 2.2 6.2 4.5 1.8 0.1 3.9-12.4 5.3-0.9-0.3-4.8 3.1-6.6-0.8-4.5 3.5z",
        label: [727.5, 104.3],
        bbox: [689, 54.5, 781.4, 139.8],
    },
    {
        code: "305",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Amstetten",
        d: "M669.6 209l-1.5 5.7-4.3-1.1-7.8-6.1-8.2-6-4.6-6.1 0.4-6-0.2-2.8 2.8-3 1.8-1.1-3.3-7.2 1.9-4.6 0-1.3-0.2-4.5 4.5-6.2 0.7-0.6 5.1 1.2 8.1 7.8 2.6 2.9 5.8 3.5 3.4-4.1 6 0.2 1-0.3 9.2-2.8 2.1-3.4 3.7-4.1 7.6 1 2.3 4.8 1.5 0.7 0.7 0.3 1.7 0.3-2.8 4.7-0.1 2.4 1.4 9.2 4.4-1.2-1.9 8.7-2.1-0.2-1.3 5.9-6.1 0.8-8.7 2.8 0 0.8-2.4 1.1-3.5 4-7.9 2.3-2.1-2.4-6 0.2-3.7 3.8zM698.5 240.5l-5.3 3.3 1.8 9.6-5.1-0.8-6.6 3.5-3.7-4.3-3.4-8-0.3-11.5 6.8-4.2 0.9-1.4 8.6-6.4-0.7-10.6 11.6-1.1 4 0-1 8.8 8.5 2.6-5.4 2.4-3.6 6.5 1.1 4.3-8.2 7.3z",
        label: [664.2, 188.7],
        bbox: [643.2, 158.1, 715.3, 256.1],
    },
    {
        code: "314",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Lilienfeld",
        d: "M825.4 204.1l0.4 7.2-6.9 4.2-2.6 0.4-5.1 0.2-8.8 7.6-3-1.5-5.6 5.4 0.7 3.9 0.2 7.4-2.5 12.4-12.6 0.9-0.9-4.1-5.9-0.3-10.5-10.4-4.3-0.4-0.1 0-5.9 0.9-1.4 5.7-9.2-0.9-5.7-10.5 11.5-5.8 0.9 0.6 8.6-2.3 7.9-2.5 4.5-10.4 1.8-0.6 6.7-3.8 4.5-5.4-0.1-0.9-0.7-8.3 4.1-2.9 5.5 0.8 11.4-4.1 3.6 1 1.9 1.2 5.8 1.1 4.5-1.2 4.3 3 3.9-2.7 6.1 4.4 3.2 10.5-10.2 0.2z",
        label: [798.1, 205.7],
        bbox: [735.7, 186.6, 835.6, 252.2],
    },
    {
        code: "308",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Gänserndorf",
        d: "M928.6 180.3l-2.7-1-1.1-0.8-8.1-2.6-5.2-6.2 2.1-11.9-0.7-4.6-4.2-4.3-1.6-1 3-7.3 3-0.6 2.9 1 4.1 2.3 7.5-4.5-8.2-8-0.1-2.1-2-5.6-3-1.8-1.2-7 7.4 0.2 4 0 2.6-3 0.9-8 1.4-0.6 0.6-6.9 2.8-4.9-3.2-8.1 0.1-0.3 4.2 1.8 8.9-2.7 0.6 0.8 1.6 0.5 1.9 2.4 6 1.3 0.2-4.8 8.9-0.9 0.9 7.1 0.4 7-2.1 9.5-5.3 7.4-3.8 7.4 1.4 4.1-2.6 11 8.4 6.4-0.8 5.5 6.6 7.7 1.3 7.7 1.8 8.7-5.1-0.6-4.7 6.5-3.7-1.3-6 5.6-8.9-0.1-0.4-1-10.8 0.6z",
        label: [938.9, 158],
        bbox: [907.1, 81.1, 968.2, 180.8],
    },
    {
        code: "318",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Neunkirchen",
        d: "M861.3 290.6l2.3 8.5-0.7 6.6-2.8 1.2-3.4-11.7-3.1 2.9-2.9 4-8.4-5.7-5.3-0.4-4.9-2.3-0.9-0.1-1.1-5.6-7.5-1.5 1.7-9.4-2.6-0.3-7.6-4.6-5 0-2.2-0.8-0.8-12.2-5.2 2.1-5.5-3.1-3.2-6.9 2.5-12.4-0.2-7.4 14.3-1.4 5.5 3.9 3.4 10.9 6.6-6.7 5.9-1.4 8.3 3.8 4-1.6 0.2 0.2 6.2 1.5 4.8 1.3 0.2 0.5 4.8-1.4 6.6 5.9-4.1 3.5 1.2 1.7 5.2-0.7 1.2 3.1-5.1 3.3 5.2 6.4-0.1 0.2-1.8 11.4-1.2 0.8-0.8 1.5 1.8 4.9 2.6 9.1-8.1-1.6z",
        label: [842.1, 263.7],
        bbox: [792.2, 230.1, 869.4, 306.9],
    },
    {
        code: "309",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Gmünd",
        d: "M700.9 84.4l-4.5 1-7.3 3.2-0.1 8.9-9.7 0.2-5.8-6.1 3.9-3.5 0.1-6.9 0.2-7.1 2.2-4.9 8.7-6.3 2.7-8.9 6.7 0.1 10.7 3.2 0.8-11.6 2.3-13.7-1.5-11.6 2.8-6.9 3.1-5.5 10.8 4.7 6.8 1.2 0.2 9.2-0.1 0.1 3.6 3.5 0.1 8.3-3.3 1.5 1 10.9-1.8 3.4-1.2-0.6-3.9 7.8 3.6 4.3 0.5 6.2-1.2 3.2-1.9-4.6-9.2 2-7.8-0.5-2.1 5.6 5.3 4.9-2.2 4.5-12.5 0.8z",
        label: [697.5, 71.5],
        bbox: [673.5, 8, 737.6, 97.7],
    },
    {
        code: "310",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Hollabrunn",
        d: "M845.4 108.7l-4.8-1.1-7.4 4.3-1.2-0.5-4-2.8-6.3 1.5-7.3 0.3-6.1-10.2 3.4-0.5-2.7-6 10.7-2.8 2.1-3 5 0.1 3.5 0.9 0.6-10.5 3.8-2.6-5.1-2-9-1.8-2.1-1.2 0-8.3 6-2.4 2.2-6.2 1.1-0.8-8.9-3-2.4-4.5-5.5 0-0.5-5.3 3.4-4.4 6.2 0.8 18.4 14.5 12.2 7.7 3.1 1.4 1.8 0.4 6 0.5 9.5 0.5-1.7 7.3-1.4 7.7 7.5 1.4 1.4 10 4.3 1.5-1.6 5.4-0.8 2.4-6.6-3.2-5.2 5.8-0.3 9.1-2.5 4-9.3 1.4-3.3-5.7-5.9 0.6-0.3-0.7z",
        label: [850.8, 88.3],
        bbox: [808.3, 35.9, 881.2, 114.5],
    },
    {
        code: "315",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Melk",
        d: "M761.1 196.3l-2.7 2.6-9.4 3.4-1.3-8 3-1.9-5-5.1-0.7-1.2-3.1-3-3.2-4.7-4.4 2.9-0.8-3.4-1.9-2.3-2.1 1.7-4.2-0.2-5.7 1.5-1.1 0.5-1 1.2-2.2 0.9-4.4 1.2-1.4-9.2 0.1-2.4 2.8-4.7-1.7-0.3-0.7-0.3-2.8-3.9 2.3-5.1 2.8-1.9-0.9-8.3-5.3-4.7 0.5-1.9 2.2-8.6 6.5 2.1 5.2 2.3 4.5 1.7 6.2 2.6 0.2-2.3 4.5-3.5 6.6 0.8 4.8-3.1 0.9 0.3 8.6 5.6-5.1 7-1.1 5.4 12.1 1.5 0.9-0.8 2.6-9.3 2.4 0.2 4.7 1.4 5.5-0.6 2.1 4.5-0.4 2.2-4.8 4.8-5.9 7.2-2 2.1 2.1 5 0.8 1.5 2 3.6-0.8 3 8.2 0.6-0.2 2-3.2 2.7-6 2.5-0.4 4.4-3.8 4.3-5.4 3.5z",
        label: [734.2, 157.8],
        bbox: [706.1, 131.1, 780.9, 202.3],
    },
    {
        code: "320",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Scheibbs",
        d: "M717.8 251l-8 1.8-9.2 6.2-5.6-5.6-1.8-9.6 5.3-3.3 8.2-7.3-1.1-4.3 3.6-6.5 5.4-2.4-8.5-2.6 1-8.8-4 0-7.9-9.4 8.7-2.8 6.1-0.8 1.3-5.9 2.1 0.2 1.9-8.7 2.2-0.9 1-1.2 1.1-0.5 5.7-1.5 4.2 0.2 2.1-1.7 1.9 2.3 0.8 3.4 4.4-2.9 3.2 4.7 3.1 3 0.7 1.2 5 5.1-3 1.9 1.3 8-0.9 0.8 2.2 10.8 4.6 2 1.8 8.8-8.6 2.3-0.9-0.6-11.5 5.8 5.7 10.5-2.3 8.2-8.4-0.9-5.8 3.2-7.1-2.2z",
        label: [727.6, 205.1],
        bbox: [693.2, 175.6, 756.7, 259],
    },
    {
        code: "307",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Bruck an der Leitha",
        d: "M920.8 220.4l-1.5 1.6-2.2 3-0.8 0.4-4.2-6.4-2.9-4.6 1.7-1.2 1.2-3.1 1.3-1.9 1.1-3.4-7-6-1.4 1-3 3.7-1.7 2.5-6-2.6-0.2-0.1-0.3-0.8-0.6-9.1 1.6-6.9-1.8-1-3.4-0.9 1.7-5 3.1 1.4 3.2-0.4-0.1-3.4 10-4 8 4.5 0.1-1.8 8.1 2.6 1.1 0.8 2.7 1 10.8-0.6 0.4 1 8.9 0.1 6-5.6 3.7 1.3 4.7-6.5 5.1 0.6 3 2.6 8.1 6.8 0.6 0.9-4 6.6-3.7-1.4-1.2-3.4-1.5-0.4-2 2 3.6 3.2 2.3 2-2.9 5.4-3.2 3.7-7-5.9-1.4-2.7-3.9-0.2-5.9 8.2-0.4 0-15.8 3.4-0.2 7.2-4.6 3.2-3.3 2.2-1 2.3 0 0.1-3 4z",
        label: [920.4, 191.9],
        bbox: [890.7, 170, 979.9, 225.4],
    },
    {
        code: "321",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Tulln",
        d: "M857.2 154.4l-3.2 2.7-4.8 2-6.6 5.4-10.7-11.2-3.4 0.2-1 5.7-5.6 0.2 0.5-9-1.6-1.9-3.8 0-5.6-5.1 2.9-4.2 5.3 0.1 1.4-6.7-8-1.3-5.3-1.3 0.4-2.6 2.9-2.9 3.2-13.2 0.2-0.9 7.3-0.3 6.3-1.5 4 2.8 1.2 0.5 7.4-4.3 4.8 1.1 0.3 0.7-0.9 11.4-3.2 1.3-0.8 9.3 6.7 0.5 8.9 5.8 4.7-1.8 0.1 0 2.7-0.9-0.2-1 9.5 1.3 2.9 0.4 2.4-0.5 1 0.2 5.9 5.5 3.8 8.6-1-0.2-9.1 4.8-3.7 3.5-6.3-4.6-0.8-0.7-3.1-2.8-2.3 0.4-3.5 4.4-2.2 0.1zM840.5 120.5l-0.3 1.2 1.4 0.2-1.1-1.4z",
        label: [843.4, 145.5],
        bbox: [807.7, 107.6, 889.2, 164.5],
    },
    {
        code: "306",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Baden",
        d: "M912.1 210.1l-1.2 3.1-1.7 1.2-8.5 1.8-3.9 6.2-4.3 3.9-12.5-5.6 0.1-0.1-7.5-1.2-2.1 3.8-1.9-1.5-7 4 0 0.1-0.1 0.1-4.9 1.5-3.2-4.5-9.6 1.2 0.6-7.5-2.4 1.7 0.1-3.6-2.5 1.8-13.8-5.2-0.4-7.2 10.2-0.2-3.2-10.5-6.1-4.4 5.2-2.4-0.4-3.5 10.7-7.4 6.9 1.5 1.1 1.1-1.4 9.6 7.5 3.9 7.2-0.5 8 7 3.5-2.3 2 1 4.8-1.8 6.8 4.1-0.2 0.9 6.9 2.3 0.3 0.8 0.2 0.1 6 2.6 1.7-2.5 3-3.7 1.4-1 7 6-1.1 3.4-1.3 1.9z",
        label: [858.8, 208],
        bbox: [825.4, 175.7, 914.5, 227.4],
    },
    {
        code: "313",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Krems (Land)",
        d: "M766.2 141.4l-2.6 9.3-0.9 0.8-12.1-1.5 1.1-5.4 5.1-7-8.6-5.6 12.4-5.3-0.1-3.9-4.5-1.8-2.2-6.2-3.4-0.6 4.6-6.8-1.7-4.6 2.2-2-2.4-8.5 1.7-3.5 5.3 3.6 6.9-1.2 2.8-5.9 9.3 3.8 2.3-6.1 7.2 1.2 5.3 11.8 9-0.9 4.8-3.3 1.3 1.9 2.7 6-3.4 0.5 6.1 10.2-0.2 0.9-3.2 13.2-2.9 2.9-0.4 2.6-0.8 1-6.9-5.7-3.4-7.1-2-0.7-4.5 1.2-8.2 4.1 3.6 5.8 5.9-2.2 2.9 6 5 0.6-1.6 6-3.4 2.2-10.1-2.3-5.4 3.5-5.5 0.6-4.7-1.4-2.4-0.2z",
        label: [774.4, 107.3],
        bbox: [748.2, 83, 814.4, 151.5],
    },
    {
        code: "311",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Horn",
        d: "M807.7 91.8l-4.8 3.3-9 0.9-5.3-11.8-7.2-1.2-0.6-3-6.3 0.5-6.4-5.1 0.5-1.1 3.5-1.3-2.5-7.5 5.6-1.1 5.4-11.5 1.8-6.7 3.9-1.6 2.8-12.7 4.2 0 9.4 7.7 7.8 0.7 0.5 5.3 5.5 0 2.4 4.5 8.9 3-1.1 0.8-2.2 6.2-6 2.4 0 8.3 2.1 1.2 9 1.8 5.1 2-3.8 2.6-0.6 10.5-3.5-0.9-5-0.1-2.1 3-10.7 2.8-1.3-1.9z",
        label: [797.2, 65.3],
        bbox: [768.1, 31.9, 834.7, 96],
    },
    {
        code: "312",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Korneuburg",
        d: "M893.3 141.8l-4.1 7.7-3.8-8.6-5.9-5.5-1-0.2-2.4 0.5-2.9-0.4-9.5-1.3 0.2 1-2.7 0.9-0.1 0-4.7 1.8-8.9-5.8-6.7-0.5 0.8-9.3 3.2-1.3 0.9-11.4 5.9-0.6 3.3 5.7 9.3-1.4 2.5-4 0.3-9.1 5.2-5.8 6.6 3.2 0.8-2.4 3.1-4.5 0.6-0.6 10 3.6 2.5 8-1.4 4 3-0.2 0.5 0 0.5 7.1-3.5 5.1 3.9 1.4-0.3 6.7-1.2 1.3-1.3 4 3.5 4.6 2.6 1.3 4.6 1.1 1.7 1.6 1.7 1.1-3 7.3-3.6 2.9-6-8.6-4.2-0.4zM841.6 121.9l-1.4-0.2 0.3-1.2 1.1 1.4z",
        label: [879.5, 119.1],
        bbox: [840.2, 89.9, 910.1, 150.8],
    },
    {
        code: "322",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Waidhofen an der Thaya",
        d: "M744.1 59.7l-2.2 2.7-5.9 5.1-3.5 1-0.5-6.2-3.6-4.3 3.9-7.8 1.2 0.6 1.8-3.4-1-10.9 3.3-1.5-0.1-8.3-3.6-3.5 0.1-0.1 8.3-3.5 4.8 1.2 3.8-5.9 3.9 1.6 5.9-1.1 8 5.9 5.1-0.1 5.8 7.2 9.5 3.5-2.8 12.7-3.9 1.6-1.8 6.7-5.4 11.5-5.6 1.1 1-4-5.1-7-6 0.9-2.8-0.2-2.1 4.4-10.5 0.1z",
        label: [757.5, 36.1],
        bbox: [728.4, 14.9, 789.1, 68.5],
    },
    {
        code: "317",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Mödling",
        d: "M894.3 193.4l0.6 9.1-6.9-2.3 0.2-0.9-6.8-4.1-4.8 1.8-2-1-3.5 2.3-8-7-7.2 0.5-7.5-3.9 1.4-9.6 2.8 0.4 8.9-4.9 1-2.6 3.3-0.4 2 3.2 3.3 0.2-0.7 4.9 1 0.5 0.5-0.3 8.9 0.3 1.8 1.1 6.9-1.8 0 0.1 2.9 0.6-1.7 5 3.4 0.9 1.8 1-1.6 6.9z",
        label: [872.2, 188],
        bbox: [848.4, 170.8, 895.9, 202.5],
    },
    {
        code: "303",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Waidhofen an der Ybbs (Stadt)",
        d: "M692.2 220.3l-0.7-10.6 11.6-1.1-7.9-9.4 0 0.8-2.4 1.1-3.5 4-7.9 2.3-2.1-2.4-6 0.2-3.7 3.8-1.5 5.7 2.8 1.4 7.4 0 5.3 10.6 8.6-6.4z",
        label: [684.9, 213.5],
        bbox: [668.1, 199.2, 703.1, 226.7],
    },
    {
        code: "302",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Sankt Pölten (Stadt)",
        d: "M796.7 180.1l-0.1-10.2 6.1-4 4-2.8 1.4-9 0.2-1.6-8.7 1-6.5 4.4-2.3 1.2-3.2 3.8-2.2 8.8 3.3 7.2 8 1.2z",
        label: [797.3, 162.3],
        bbox: [785.4, 152.5, 808.3, 180.1],
    },
    {
        code: "304",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Wiener Neustadt (Stadt)",
        d: "M866.9 240.6l-1.6 6.4-4.1 3.5 1.2 1.7 5.2-0.7 5.9-4.5 3.5-3.3 2.2-4-0.6-5.5-1.2-2.7-6.3-3.3-4 5.2-0.2 7.2z",
        label: [872.8, 238.7],
        bbox: [861.2, 228.2, 879.2, 252.2],
    },
    {
        code: "301",
        state: federal_state_1.FederalState.NIEDEROESTERREICH,
        name: "Krems an der Donau (Stadt)",
        d: "M791.4 126.4l2.9 6 5 0.6 2.5-0.3 5.1-1.7-6.9-5.7-3.4-7.1-2-0.7-4.5 1.2-8.2 4.1 3.6 5.8 5.9-2.2z",
        label: [793.9, 122.7],
        bbox: [781.9, 117.5, 806.9, 133],
    },
    {
        code: "407",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Gmunden",
        d: "M545 284.3l5.3 0.4 3.2 10.9-1.5 3.5-3.4 7.6-14.7-2.5-0.4 0-2.5 0.1-9-4.2-5.1-6.5 0.6-6 5-11.8-3.9-1.3 3.5-8.7 4.4-7.4-14.8-4.7 3.7-9.1 9.1 1.9 5.4 2.9 8.2-10.3-3.4-2 0.4-5.2 4.4-3.1 2.5-8.1 4.7-3.2 0.1-0.3 4.7-5.7-0.6-4.2 7-3 0-2.1 2.2-3.8 3.1-3.7 1.8-1.5 4.2 7.7 5.1-3 3-0.3 5.4 5.5-0.1 10.4-1.1 6.5 1.8 6.8 11.3 3.7 2.4 2.8-12.1 11.2 7.1 11-6.3 5.4-14.7-3.1-4.6-1.9-10.7 1.7-9 11.9-1.2 10.4-0.5 4.4z",
        label: [561.5, 233.4],
        bbox: [511.7, 193.2, 597, 306.7],
    },
    {
        code: "415",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Steyr-Land",
        d: "M675.9 232.3l0.3 11.5 3.4 8-5.3-3.3-6.6 7.7-14.7 2.3-5.6 6.1-3-4.8 3.1-7.8-2.6-4.5-7.1-5.4-2.8-4.5 0.9-11.5-5-4.3-8.6-1.3 3-10-2.9-7.5-3.5 5.7-5.1-0.1-1.1 0.8-4.5-5.2-0.8-0.2-2.5-3.9 2.9-3.6 1.3-3.2-0.5-3.8 2-2 4.8-0.4 1.2-3.6 10.1-1.7 0.8-1.8 7.9-1.9 0.2 0.9 3.4 0.7 7.2 3.9-2.8 3-6.1 2.4-3.1 3.1-1.2 3.1 5.1 3.9 5.1-3.7 4.6 6.1 8.2 6 7.8 6.1 4.3 1.1 2.8 1.4 7.4 0 5.3 10.6-0.9 1.4-6.8 4.2z",
        label: [655.7, 232.2],
        bbox: [604.9, 178.1, 683.6, 264.6],
    },
    {
        code: "409",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Kirchdorf",
        d: "M638.7 269.4l-3.8 4-8.4 5.4-8-0.5-4.1-7.7-3.5-0.4-3.6 2.8-10.9 3.5-5.5 0.5-0.2-3.8 0.8-5.9-5.8-6.4 6.3-5.4-7.1-11 12.1-11.2-2.4-2.8-11.3-3.7-1.8-6.8 1.1-6.5 0.1-10.4 4.7-2 1.9-7.8 4.5 0.6 2.9-5.4 5.1-3.8 6.8 4.8 0.5 3.8-1.3 3.2-2.9 3.6 2.5 3.9 0.8 0.2 4.5 5.2 1.1-0.8 5.1 0.1 3.5-5.7 2.9 7.5-3 10 8.6 1.3 5 4.3-0.9 11.5 2.8 4.5 7.1 5.4 2.6 4.5-3.1 7.8 3 4.8-5.7 5.1-3-0.3z",
        label: [614.5, 247.4],
        bbox: [581.5, 184.7, 647.5, 278.8],
    },
    {
        code: "417",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Vöcklabruck",
        d: "M535.1 231.9l-0.4 5.2 3.4 2-8.2 10.3-5.4-2.9-0.8-4-10.2-1.3-6.7 1.2-6.1-2.3-5-0.6-2.5-9.8-2.9-5.3 1.4-2.5-0.1-9.6 3.5-1.8 6.6 4.7 0.5-0.9 1.2-5.3-8.8-6.9 3.4-11.8 3 2.7 3.8 0.8 1.2-1.4 1.6-5 5.9-3.8 1.2-0.5 2.2 0.1 6.5-1.6 3.2-0.9 3.9 0.9 3.1-3.4 7.5 1.3 0.1-0.4 5.7 0.7 5.8 1.2 4.2 3 1.2-0.2 3.4 5 0.5-0.1 1.2 6-3.1 3.7-2.2 3.8 0 2.1-7 3 0.6 4.2-4.7 5.7-0.1 0.3-4.7 3.2-2.5 8.1-4.4 3.1z",
        label: [525.2, 204.9],
        bbox: [490.3, 178.2, 563.2, 249.4],
    },
    {
        code: "404",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Braunau",
        d: "M498.1 178.3l-0.8 4.8 0.7 7.2-3.4 11.8-11.8 4.9-0.3 0.6-1.5 1-6.9-0.1-2.7-4.2-2.6-0.1-0.1-0.1-5.8-3-1.4-2.7 0-2-4.5 0.2-2.9 1.7-6.5-1.7-0.2 0.1-5.9 8.6-4.1-1-3.4-6.1-8.2-7.2-2.5-6.5 5.4-6.3 7.1-6.8 3.3-6.6 10.5-1.2 8.2-9.1 5.9-2.5 10.1-2.6 6.8-2.4 1 5.3 0.5 1 6.4-2.2 2 4.2 6.3 2.4 3.1 3.2-1.1 0.9 2.1 4.1-2.8 12.4z",
        label: [473.4, 175.2],
        bbox: [423.3, 147, 500.9, 208.6],
    },
    {
        code: "406",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Freistadt",
        d: "M655.7 141.5l-4.5 1.6-5.2-2.4-2.3-4.6-2.5-0.7-1-1.8 4.3-5.8-6.7-6.9-1.4-5-0.4-4.4-3.3-9.3-0.2-1 8.1-1.5-5.4-6.8 6.4-5.1 4-7.6 3.8 5.1 6.5 2.2 6.7-4.4 2.6 4.7 8.3 3.8 5.8 6.1 9.7-0.2 8.2 5 6 4.2-5.7 7.9 4.5 5.7 2.1 2.1-10.4 10.3-7.5 6.4-1.4-1.3-5.4 2.3-3.2-1.3-4.3 5.1-0.1 0.4-4.7-5.7-3.6 7.1-5.3-0.4-1.2-3.2-1.3-0.6z",
        label: [660.8, 111.6],
        bbox: [632.5, 80.2, 704.1, 145.7],
    },
    {
        code: "413",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Rohrbach",
        d: "M594.9 123.7l-3.6 5.8-3 2.6-6.6-9.2-0.5 0.4-4.1 3-3.2-8.8-8.3 0.2 1.9 4.3-0.5 0-9.7-7.7-2-1.5-6.1-7.5 4.8-9.1 4.7-2.6 3.2-8.6-1.1-7.6 2.1-6.4 0.5-1.6-2.1-10.4 7.2-2.2 6.4 6 6.5 4.5 3.4 0.5 7 9.7-6.1 3.5 4.1 5.1 6.9 4 8.8 0.6-0.9 4.8 4.9 7.6-2.1 4 0.1 8.9-5.9 4.1-6.7 3.6z",
        label: [576.8, 99.2],
        bbox: [549.2, 56.8, 609.5, 132.1],
    },
    {
        code: "411",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Perg",
        d: "M707.2 161.6l2.8 3.9-1.5-0.7-2.3-4.8-7.6-1-3.7 4.1-2.1 3.4-9.2 2.8-1 0.3-6-0.2-3.4 4.1-5.8-3.5-2.6-2.9-8.1-7.8-5.1-1.2-3.4-1.2-7-0.1-0.5 0.9-3.6-1.7-0.7-1.7 1.8-9.1 3.3 1.7 5.1-1.3-0.6-4.9 5.2 2.4 4.5-1.6 1.3 0.6 1.2 3.2 5.3 0.4 3.6-7.1 4.7 5.7 0.1-0.4 4.3-5.1 3.2 1.3 5.4-2.3 1.4 1.3 7.5-6.4 10.4-10.3 3.6 6.2 1.1 2.5-2.2 8.6-0.5 1.9 5.3 4.7 0.9 8.3-2.8 1.9-2.3 5.1z",
        label: [682.3, 154.3],
        bbox: [636.4, 122.4, 712.3, 173.5],
    },
    {
        code: "414",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Schärding",
        d: "M539.8 149l-0.6 4.2-2.8 2.4-4.8-0.6 4.8-7.1-2.4-1.6-5-2-1.1-3.6-3.9-0.7-4.1-0.3-4.5-0.2-5.2-2.4 0.1-1.1-2.3-3.7 1.6-5.4 2-4.9-0.2-3.7 0.7-6.5 0.5-1.2 0.2-8.2 3.9-5.4 4.7-6.7 5.1 3.9 11.6 3.5 4.7 4.2 6.4 3.4 6.1 7.5 2 1.5 9.7 7.7-3.2 1.8-4.4-0.8-4-3.4-2.6-0.2-7.5 0.9-1.5 5.3 2.4 4 1.6 1.7-0.1 8.7-0.7-0.2 0 3.7-4.7 1.6-0.3 0.1-2.2 3.8z",
        label: [528.9, 116.1],
        bbox: [508, 90.3, 567, 155.6],
    },
    {
        code: "416",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Urfahr-Umgebung",
        d: "M638.2 145.2l-1.8 9.1-7.6-5 1.9-7.9-1.4-3.3-7.3-6.9-0.1 0.2-4.6 6.7 0.2 2.9-1.1 3.2-1.9 0.4-3.8-2.6-7.7 1.2 0.2-0.9-9.7 0.3-0.6-0.2-5.2-3.6-0.4-3 1-3.7 3-2.6 3.6-5.8 6.7-3.6 5.9-4.1-0.1-8.9 2.1-4-4.9-7.6 0.9-4.8 13.8 1.5 8.1 5.6 1-0.5 6.8-4.4 5.4 6.8-8.1 1.5 0.2 1 3.3 9.3 0.4 4.4 1.4 5 6.7 6.9-4.3 5.8 1 1.8 2.5 0.7 2.3 4.6 0.6 4.9-5.1 1.3-3.3-1.7z",
        label: [621.9, 115.9],
        bbox: [587.3, 90.7, 646.6, 154.3],
    },
    {
        code: "412",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Ried",
        d: "M514.7 183.1l-1.2 0.5-5.9 3.8-1.6 5-1.2 1.4-3.8-0.8-3-2.7-0.7-7.2 0.8-4.8 2.8-12.4-2.1-4.1 1.1-0.9-3.1-3.2-6.3-2.4-2-4.2-6.4 2.2-0.5-1-1-5.3 7.5 0.4 7.9-4.4 3.4-3 0.4-0.3 3.9-4.4 4.3-3 2.3 3.7-0.1 1.1 5.2 2.4 4.5 0.2 4.1 0.3 3.9 0.7 1.1 3.6 5 2 2.4 1.6-4.8 7.1-3 1.9 2.2 3.5 0 2.4 3.4 2 0.1 6.4-0.5 5.1-0.2 1.9-3.1 3.4-3.9-0.9-3.2 0.9-6.5 1.6-2.2-0.1z",
        label: [513.2, 154.1],
        bbox: [480.6, 132.3, 536.4, 193.8],
    },
    {
        code: "408",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Grieskirchen",
        d: "M570.9 155.3l4.6 1 4.7 0.2 3.1 1.6 0.3 3.8-8.2 0.7-1.8-1.3-0.9 0.4-8.6 2.5 3.9 8-5.9-2-3 5.4-2.7-0.5-1.4 4.1-2.3 1.8-5.8-1.2-5.7-0.7-0.1 0.4-7.5-1.3 0.2-1.9 0.5-5.1-0.1-6.4-3.4-2 0-2.4-2.2-3.5 3-1.9 4.8 0.6 2.8-2.4 0.6-4.2 2.2-3.8 0.3-0.1 4.7-1.6 0-3.7 0.7 0.2 0.1-8.7-1.6-1.7-2.4-4 1.5-5.3 7.5-0.9 2.6 0.2 4 3.4 4.4 0.8 3.2-1.8 0.5 0 6.3 7-2.6 3.2 1.7 6.4-7.4 8.5 0.2 0.9 6.7 1.2-3.1 1 1.6 5.1z",
        label: [549.2, 163],
        bbox: [528.6, 119.4, 583.6, 181],
    },
    {
        code: "410",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Linz-Land",
        d: "M610.6 187.5l-2 2-6.8-4.8 3.3-2.7-5.6-2.2 3.9-5 2.9-4.8-2-2.3 0-6.3-4.4 0.2-1.5-5.2-2-1.8 9.2-4.2-2.6-7.2 7.7-1.2 3.8 2.6 1.9-0.4 1.9 12.1 2.4 2.4 5.6 4.4 7.8-3.7 3-3.4 3.6 1.7 0.5-0.9 7 0.1 3.4 1.2-0.7 0.6-4.5 6.2 0.2 4.5 0 1.3-1.9 4.6 3.3 7.2-1.8 1.1-7.2-3.9-3.4-0.7-0.2-0.9-7.9 1.9-0.8 1.8-10.1 1.7-1.2 3.6-4.8 0.4z",
        label: [618.3, 171.7],
        bbox: [596.4, 142, 651.6, 189.5],
    },
    {
        code: "418",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Wels-Land",
        d: "M589.3 193.3l-1.9 7.8-4.7 2-5.4-5.5-3 0.3-5.1 3-4.2-7.7-1.8 1.5-1.2-6-0.5 0.1-3.4-5-1.2 0.2-4.2-3 2.3-1.8 1.4-4.1 2.7 0.5 3-5.4 5.9 2-3.9-8 8.6-2.5 0.9-0.4 1.8 1.3 8.2-0.7-0.3-3.8 8.7-2.8 2.3 0.8 2.1-1.5 2 1.8 1.5 5.2 4.4-0.2 0 6.3 2 2.3-2.9 4.8-3.9 5 5.6 2.2-3.3 2.7-5.1 3.8-2.9 5.4-4.5-0.6zM580.7 179.5l3.6-3.1 7.1-3 4.5-2.7-2.1-4.7-9.9-1.8-4.2 4.4 1 10.9z",
        label: [571.7, 184.9],
        bbox: [552.7, 154.6, 606.3, 203.1],
    },
    {
        code: "405",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Eferding",
        d: "M592.9 142.4l0.6 0.2 9.7-0.3-0.2 0.9 2.6 7.2-9.2 4.2-2.1 1.5-2.3-0.8-8.7 2.8-3.1-1.6-4.7-0.2-4.6-1-1.6-5.1 3.1-1-6.7-1.2-0.2-0.9 7.4-8.5-1.7-6.4 2.6-3.2-6.3-7-1.9-4.3 8.3-0.2 3.2 8.8 4.1-3 0.5-0.4 6.6 9.2-1 3.7 0.4 3 5.2 3.6z",
        label: [582.2, 147.1],
        bbox: [565.5, 117.5, 605.6, 158.1],
    },
    {
        code: "401",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Stadt Linz",
        d: "M626.3 163.1l7.8-3.7 3-3.4-0.7-1.7-7.6-5 1.9-7.9-1.4-3.3-7.3-6.9-0.1 0.2-4.6 6.7 0.2 2.9-1.1 3.2 1.9 12.1 2.4 2.4 5.6 4.4z",
        label: [623.3, 144.5],
        bbox: [616.4, 131.2, 637.1, 163.1],
    },
    {
        code: "403",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Stadt Wels",
        d: "M580.7 179.5l3.6-3.1 7.1-3 4.5-2.7-2.1-4.7-9.9-1.8-4.2 4.4 1 10.9z",
        label: [585.8, 169.9],
        bbox: [579.7, 164.2, 595.9, 179.5],
    },
    {
        code: "402",
        state: federal_state_1.FederalState.OBEROESTERREICH,
        name: "Stadt Steyr",
        d: "M638.1 199.1l5.1-3.7 0.4-6-0.2-2.8-6.1 2.4-3.1 3.1-1.2 3.1 5.1 3.9z",
        label: [639.2, 193.1],
        bbox: [633, 186.6, 643.6, 199.1],
    },
    {
        code: "506",
        state: federal_state_1.FederalState.SALZBURG,
        name: "Zell am See",
        d: "M460.7 348.2l0.3 10-2.7 8.8 2 11-4.5 8.9-2.3 1.6-4.1-2.7-2.1-5.1-15.1-4.1-10.5-0.5-1-5.9-8.3 1.6-1.2 4.4-8.4-4.8-3.3-2.2-10.7-4.2-2.3 2.6-8.5-1.6-4.7 2.2-2.3 6.1-7.9 3.2-5.6 4.5-7.1-4.4-6.4 2.2-5.5-12.5-1.4-9.5 3.6-8.6-4.1-6.7 4.6-6 6.5 1 7-1.8 4.6 0.6 1.2 1.1 4.2-5 5-0.1 5.1 3.3 13.3-2.9 2.2-2.1-2.1-5.9 3.5-4.9 5.1-0.8 4.3 1.1 5.9-5.8 1-1.8 0-6.4 8.7-2.4-4.5-5.4-1.4-5.9-3.3-2.5 3.2-7.3-10.2-3.3 0.1-5.2 3.7-7.7 8.1-1.7 10.1 1.1 5.8 8.1 0.2 6.7-1.6 3.7 1 2.1 12.6 10.6 6.1 4.8 8.9 4.6 2.2-2.1 4.6 10.4-1.4 9.5 3 2.2-4.9 6.2 0.8 4.3 3.9 1.4 1.5 1.9-4.5 8z",
        label: [427.7, 339.5],
        bbox: [336.6, 264.7, 465.2, 388.5],
    },
    {
        code: "504",
        state: federal_state_1.FederalState.SALZBURG,
        name: "Sankt Johann im Pongau",
        d: "M491.2 377.1l-3.8 8.5-21.6 4.6-1 2.5-9-5.8 4.5-8.9-2-11 2.7-8.8-0.3-10 4.5-8-1.5-1.9-3.9-1.4-0.8-4.3 4.9-6.2-3-2.2 1.4-9.5-4.6-10.4 3.6-8.8 6.9 0.9 8.7-7.3 5.8 1.2 3 3.4 4.8-0.8 3.4 4.1 8.9-1.1 7 11 1.8 0.5 10.4-7.3 9 4.2-2.8 10.9 0 0.2 1 4.5 3.6 10.1 1 11-3.6 3.3-0.1 1.9-12.2 5.3-3.8 2.1-10.7 0.2-7 11 2.4 3 2.3 8.9-9.9 0.4z",
        label: [491.6, 328],
        bbox: [455.8, 289.1, 533.8, 392.7],
    },
    {
        code: "503",
        state: federal_state_1.FederalState.SALZBURG,
        name: "Salzburg-Umgebung",
        d: "M511.7 253.7l14.8 4.7-4.4 7.4-3.5 8.7-5.2-0.9-2.7-4.1-12.1-3.7-0.8-0.7-3.8 0.9-5.5-3.1-3-7-3.9-4.1-1-3.3-3 2.5-2-1.2-9.7 3 0.2 2.3-4 1.4-0.8 2.2-7.5 1-7-0.4 1.3-10.2 5.9-13.3 1.6 13.5 6.1 0.4 3.9 0.9 6.2-9.1-5-4.8-3.7-2.9-7.5-2.3-1.8-2.8-2.7-6.1-3.5-6.9-2.4-2.7-6.4-2.9-1.4-5.8 4.1 1 5.9-8.6 0.2-0.1 6.5 1.7 2.9-1.7 4.5-0.2 0 2 1.4 2.7 5.8 3 0.1 0.1 2.6 0.1 2.7 4.2 6.9 0.1 1.5-1 0.3-0.6 11.8-4.9 8.8 6.9-1.2 5.3-0.5 0.9-6.6-4.7-3.5 1.8 0.1 9.6-1.4 2.5 2.9 5.3 2.5 9.8 5 0.6 6.1 2.3 6.7-1.2 10.2 1.3 0.8 4-9.1-1.9-3.7 9.1z",
        label: [474.5, 224.1],
        bbox: [437.4, 196.4, 526.5, 274.5],
    },
    {
        code: "505",
        state: federal_state_1.FederalState.SALZBURG,
        name: "Tamsweg",
        d: "M558.7 404.7l-2.1 1.4-1.7-6.4-9.3-5-1.6-7-6.4-3-5.6-0.1-21.4-4.9-2.8 2.3-6.7-5.3-2.3-8.9-2.4-3 7-11 10.7-0.2 3.8-2.1 12.2-5.3 0.1-1.9 3.6-3.3 11.4 4.4 2 0.2 6.3-1.3 8.4-5.2 5 7.9 0 6.1 10.1 10.3 6.5 4.6-0.7 2.9-6.7-1.5-7.4 6.7 3.7 5.8-9.7 20-4 2.8z",
        label: [549, 367],
        bbox: [496.4, 339.1, 583.5, 406.1],
    },
    {
        code: "502",
        state: federal_state_1.FederalState.SALZBURG,
        name: "Hallein",
        d: "M516.9 293.6l5.1 6.5-10.4 7.3-1.8-0.5-7-11-8.9 1.1-3.4-4.1-4.8 0.8-3-3.4-5.8-1.2-8.7 7.3-6.9-0.9 3.3-13.3 3.4-8.4-2.4-10.4-4.3-4.7 0.8-2.2 4-1.4-0.2-2.3 9.7-3 2 1.2 3-2.5 1 3.3 3.9 4.1 3 7 5.5 3.1 3.8-0.9 0.8 0.7 12.1 3.7 2.7 4.1 5.2 0.9 3.9 1.3-5 11.8-0.6 6z",
        label: [499.6, 281.6],
        bbox: [461.3, 248.5, 522.5, 307.4],
    },
    {
        code: "501",
        state: federal_state_1.FederalState.SALZBURG,
        name: "Salzburg (Stadt)",
        d: "M465.6 250.6l6.2-9.1-5-4.8-3.7-2.9-7.5-2.3-1.6 4.3 1.6 13.5 6.1 0.4 3.9 0.9z",
        label: [462.2, 242.2],
        bbox: [454, 231.5, 471.8, 250.6],
    },
    {
        code: "612",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Liezen",
        d: "M561.9 339.1l-8.4 5.2-6.3 1.3-2-0.2-11.4-4.4-1-11-3.6-10.1-1-4.5 0-0.2 2.8-10.9 2.5-0.1 0.4 0 14.7 2.5 3.4-7.6 1.5-3.5-3.2-10.9-5.3-0.4 0.5-4.4 1.2-10.4 9-11.9 10.7-1.7 4.6 1.9 14.7 3.1 5.8 6.4-0.8 5.9 0.2 3.8 5.5-0.5 10.9-3.5 3.6-2.8 3.5 0.4 4.1 7.7 8 0.5 8.4-5.4 3.8-4 3 0.3 5.7-5.1 5.6-6.1 14.7-2.3 6.6-7.7 5.3 3.3 3.7 4.3 6.6-3.5 5.1 0.8 5.6 5.6 9.2-6.2 8-1.8 7.1 2.2-2.9 17.2 0.9 3.5-2.6 5-12.9 1.6-5.2-3-10.5 4.6-2.5 7.7-5.3-6.2-6 5.3-7.6 11.2-4.1 0.5-0.6 9.4-3.5 3.5-11.6-6.8-4.7-1.1-10 2.4 0.2 3.2-3.1 3.6-17.5 8.5-0.8 1-0.9 7.9-4.7 4.8-6.5 1.4-3.6 5.6-1.8 0.9-6.6-5-4.5 5.1-4.9-1.1-5.7 3.7-8.5-0.6-5-7.9z",
        label: [585.6, 308.4],
        bbox: [528.2, 248.5, 724.9, 347.6],
    },
    {
        code: "621",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Bruck-Mürzzuschlag",
        d: "M768 326l-3.5 9.5-7.3 0-7-5.8-5.5-0.2-1.5 1.1-4.1-4.2-2.8-8.4-2.2-7.6-6.5 0.8-7-6.3-2.2-10.5-6.8-1.8-1.1-1.2-3.1-10.9 12.9-1.6 2.6-5-0.9-3.5 2.9-17.2 5.8-3.2 8.4 0.9 2.3-8.2 9.2 0.9 1.4-5.7 5.9-0.9 0.1 0 4.3 0.4 10.5 10.4 5.9 0.3 0.9 4.1 12.6-0.9 3.2 6.9 5.5 3.1 5.2-2.1 0.8 12.2 2.2 0.8 5 0 7.6 4.6 2.6 0.3-1.7 9.4-10 0.8-2.9 2.1-0.6 0.7-6.3 5.7-0.1 0-7.1 6.6-5.3 2.2-1.8 11.5-5.9 2-0.7 7.7-6.5 0.9-7.4-0.7z",
        label: [758.5, 282.1],
        bbox: [707.4, 237, 824.3, 335.5],
    },
    {
        code: "620",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Murtal",
        d: "M694.1 384.7l-0.8 1.4-9.1 1.7-9.7 4.4-9.2 0.5-1.6 3-3.8-2.6-3.2-10.8-0.1-0.8-2.6-7.2 0.9-0.8-4.1-8.5-4.3-1.8-5.2 0.9-6.3-4.4-0.4-7.5-2.3-8.1-5.1-0.5-8.4-9.1-5.1-2.3 0.9-7.9 0.8-1 17.5-8.5 3.1-3.6-0.2-3.2 10-2.4 4.7 1.1 11.6 6.8 1.4 9.2 8.8 3 9.1 3.8 4.3-4.9 10.1 3.4 5.4 10.5 3.6 2.7 1.3-3.5 5.2 3.5 8.3 10.6 0.6 3-9.2 7-4.8 3.9-3.5 12.5-0.5 3.2-3.9-2.2-4.2 5.5z",
        label: [678, 358.2],
        bbox: [613.7, 305.6, 720.2, 395.7],
    },
    {
        code: "614",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Murau",
        d: "M577.5 406.7l-8.3 4.4-8.6-0.2-4-4.8 2.1-1.4 4-2.8 9.7-20-3.7-5.8 7.4-6.7 6.7 1.5 0.7-2.9-6.5-4.6-10.1-10.3 0-6.1 8.5 0.6 5.7-3.7 4.9 1.1 4.5-5.1 6.6 5 1.8-0.9 3.6-5.6 6.5-1.4 4.7-4.8 5.1 2.3 8.4 9.1 5.1 0.5 2.3 8.1 0.4 7.5 6.3 4.4 5.2-0.9 4.3 1.8 4.1 8.5-0.9 0.8 2.6 7.2 0.1 0.8 3.2 10.8-14.7 0.7-5.3 1.4-12.9-5.5-12 0.2-0.3 0.5-4.2-9.7-5.3 4.6-3.7-2-6.9 7.8-8.1 6.3-6.2 5-2.8 4.3z",
        label: [612.6, 360.1],
        bbox: [556.6, 332.2, 659.9, 411.1],
    },
    {
        code: "606",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Graz-Umgebung",
        d: "M783.3 398.2l0.5 1.5-3.4 10.8-4.3 2-1-0.5-3.7 1.5-2.8 4.6-1.9 0.6-4.7-4.9-3.7-4 0-5.5-4.5-3.7-2-1.9 1.8-2.2-6.7-6.2 0.6-1.8-0.3-1.8-0.6-1.1-4.1-6.9-0.9 0.5-3.9-6.3-0.5-9.8-3-6.7-6.4-0.8-7.6-0.8-0.6-3 6.4-6.7 6.3-3.7 1.7-0.6 9.2-10.2 1.5-1.1 5.5 0.2 7 5.8 7.3 0 2.2 5.3 6.8 4.4-3.7 2 3.6 10 2.8-1.4 2.7 3 10.3 0 0.3 0.3-1 4 5.3 4.9 4.4 3.5-3.1 6.5-0.2 0.3 5.8 5.8 0.9 5.4 5.2 1-5.4 8.6-4.3-0.7-4.3-3.6 0.3-1.6-4-1.5-4.6 5.1-1.2 1.4zM759.8 385.4l1.7 5.5 8.7 1.4 2.6 0.7 3.6-1.7 2-3.7 0.4-6.5 1.8-8.8-10.8-1.6-5.2-0.8-4.9 2.5-1.1 3.5 1.2 9.5z",
        label: [752.3, 353.7],
        bbox: [719.6, 329.5, 806.8, 418.7],
    },
    {
        code: "617",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Weiz",
        d: "M816.9 386.9l-5.1 5.3-5-1.7-5.2-1-0.9-5.4-5.8-5.8 0.2-0.3 3.1-6.5-4.4-3.5-5.3-4.9 1-4-0.3-0.3-10.3 0-2.7-3-2.8 1.4-3.6-10 3.7-2-6.8-4.4-2.2-5.3 3.5-9.5 7.4 0.7 6.5-0.9 0.7-7.7 5.9-2 1.8-11.5 5.3-2.2 7.1-6.6 0.1 0 6.3-5.7 0.6-0.7 2.9-2.1 10-0.8 7.5 1.5 1.1 5.6-2.2 3.9-11.1 1.7-5.3-1.6-5.5 9.2 2.8 0.4 3.2 12.5 3.5 4.1-7.4 4.2-1.2 7.9 3.2 3.9 0.1 0.4 0.1 8.9 0.7 3.7 0.8 0.8 6.9 7.5 4.6 3.3 3.6 5.7-4.4 1-1.9 8.5 4.4 3.2 0.4 4.7-1.4 2.3-2.5 1.5-2.5-2.1-3.2-2.3z",
        label: [790.9, 341.6],
        bbox: [764.5, 286.5, 831.2, 392.2],
    },
    {
        code: "622",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Hartberg-Fürstenfeld",
        d: "M859.2 393l1.9 2.3 1.1 1.8-6 4.8-5.4-7-5.8-1.2-0.3 0.2-5.6-3.4-0.7-5.4-1.7-1-2.4-0.1-7.8 3.5-0.4-4.7-4.4-3.2 1.9-8.5 4.4-1-3.6-5.7-4.6-3.3-6.9-7.5-0.8-0.8-0.7-3.7-0.1-8.9-0.1-0.4-3.2-3.9 1.2-7.9 7.4-4.2-3.5-4.1-3.2-12.5-2.8-0.4 5.5-9.2 5.3 1.6 11.1-1.7 2.2-3.9 0.9 0.1 4.9 2.3 5.3 0.4 8.4 5.7 2.9-4 3.1-2.9 3.4 11.7 4.4 7.4-0.9 0.4-3 0.6-3.3 0.7-4.1 0.9-3.1 4.8-0.2 0-3.7 0.9 0.5 1.4-0.5 0.1 0.6 3 3.2 7.9-0.1 0.9 2 6.7 0.3 0.6 1.3 7.3 0.8 6.5-0.2 0.2 1.4 2.9 0.9 3.2 0.7 6.5-2.6 4-1 4.7 1.5 5.1 4.2 9.4z",
        label: [832.2, 345.5],
        bbox: [807.1, 293.6, 864.5, 401.9],
    },
    {
        code: "611",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Leoben",
        d: "M726 345.1l-6.4 6.7-8.3-10.6-5.2-3.5-1.3 3.5-3.6-2.7-5.4-10.5-10.1-3.4-4.3 4.9-9.1-3.8-8.8-3-1.4-9.2 3.5-3.5 0.6-9.4 4.1-0.5 7.6-11.2 6-5.3 5.3 6.2 2.5-7.7 10.5-4.6 5.2 3 3.1 10.9 1.1 1.2 6.8 1.8 2.2 10.5 7 6.3 6.5-0.8 2.2 7.6 2.8 8.4 4.1 4.2-9.2 10.2-1.7 0.6-6.3 3.7z",
        label: [699.3, 308.5],
        bbox: [662.1, 277.5, 743.2, 351.8],
    },
    {
        code: "623",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Südoststeiermark",
        d: "M841.5 446.9l1 10-7-2-9-5.9-6-0.4-10.1 4.6-4.5-4.9 4.3-7.7-4.3-3.5-3.9-0.2-0.3-9.1 0.7-4.4 0.1-1.7-3.4-4.7-2.8-1.9-4.5-0.8-1.2-5.7-0.5-9.1 2.7-4.7 4.3 3.6 4.3 0.7 5.4-8.6 5 1.7 5.1-5.3 3.2 2.3 2.5 2.1 2.5-1.5 1.4-2.3 7.8-3.5 2.4 0.1 1.7 1 0.7 5.4 5.6 3.4 0.3-0.2 5.8 1.2 5.4 7-1.6 2.2-0.1 3.8-5.2 4.6-2.4 3.3-1.6 1-2.6 7.8-0.9 2.2-0.4 6 0.1 14.1z",
        label: [823.2, 414.4],
        bbox: [790.1, 384, 856.2, 456.9],
    },
    {
        code: "610",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Leibnitz",
        d: "M801.7 427.8l0.3 9.1 3.9 0.2 4.3 3.5-4.3 7.7 4.5 4.9-10.1-1.7-7.7 4.7-5.7 0.3-3.1 2-0.3 7.3-9.2 3.9-3-5.8-8.6-1.8-9.6-0.2 1.8-8.9 2.1-5.9 0-0.4 0.4-7.7 0.8-1 3.4-4.1 4.4-4.6 2.4-4.9 0.4-0.1-2.1-5.6 1.9-0.6 2.8-4.6 3.7-1.5 1 0.5 4.3-2 3.4-10.8-0.5-1.5 1.2-1.4 4.6-5.1 4 1.5-0.3 1.6-2.7 4.7 0.5 9.1 1.2 5.7 4.5 0.8 2.8 1.9 3.4 4.7-0.1 1.7-0.7 4.4z",
        label: [782.9, 437.2],
        bbox: [753.1, 391.7, 810.4, 469.7],
    },
    {
        code: "603",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Deutschlandsberg",
        d: "M721.7 462l-5.2-3.4 2.3-9.8-1.4-4.8-4.5-6.7-2.6-0.8 5.6-11.4-1.5-6.8 0.9-0.2 1.5-5.5 6.3-1.4 5.2-2.1 0.4-1.7 1.6-4.8 5.4 2.3 6-2.5 4.3-1.1 5.2 3.9 2.6-4.6 4.5 3.7 0 5.5 3.7 4 4.7 4.9 2.1 5.6-0.4 0.1-2.4 4.9-4.4 4.6-3.4 4.1-0.8 1-0.4 7.7 0 0.4-2.1 5.9-1.8 8.9-9.3 2.5-6.9-3.2-15.2 0.8z",
        label: [738.3, 428.5],
        bbox: [710.3, 400.6, 768.8, 464.4],
    },
    {
        code: "616",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Voitsberg",
        d: "M751.8 398.7l2 1.9-2.6 4.6-5.2-3.9-4.3 1.1-6 2.5-5.4-2.3-1.6 4.8-0.4 1.7-5.2 2.1-6.3 1.4-7.7-13.8-10.5-5.6-5-4.2-0.3-2.9 0.8-1.4 4.2-5.5 3.9 2.2 0.5-3.2 3.5-12.5 4.8-3.9 9.2-7 7.6 0.8 6.4 0.8 3 6.7 0.5 9.8 3.9 6.3 0.9-0.5 4.1 6.9 0.6 1.1 0.3 1.8-0.6 1.8 6.7 6.2-1.8 2.2z",
        label: [722.3, 384.9],
        bbox: [693.3, 354.8, 753.8, 412.6],
    },
    {
        code: "601",
        state: federal_state_1.FederalState.STEIERMARK,
        name: "Graz (Stadt)",
        d: "M761.5 390.9l8.7 1.4 2.6 0.7 3.6-1.7 2-3.7 0.4-6.5 1.8-8.8-10.8-1.6-5.2-0.8-4.9 2.5-1.1 3.5 1.2 9.5 1.7 5.5z",
        label: [769.1, 380.5],
        bbox: [758.6, 369.9, 780.6, 393],
    },
    {
        code: "709",
        state: federal_state_1.FederalState.TIROL,
        name: "Schwaz",
        d: "M310.2 393.4l-14.1 7.1-6.9-3.9-6 0.2-4.8-4.1 2.8-6.4 1.2-1.1-3.3-16.8 5.1-3.8-0.7-7.2 4.7-1.4-1.6-10.9-5.1-6.2-2.5-3.3-1.4 0.5-1.3-2.4-1.6-5.2-5.3-0.6-7.4-2.2-7.7-9.2-2.5-6.5-3.8-7.2 7.4-4.7 15.9-1.4 3.6-10.3 7.5-3.1 15-1.2-2.6 6.1 10.1 4-0.3 10.2-0.4 2.6-6.1 2.9-0.9 4 5.9 6.3 2.5-1.1 0.1 1.9 6.5 3.6 4.3 3.4 0.8 5 12.1 2.7-2.4 9.6 9.6-0.8 4.1 6.7-3.6 8.6 1.4 9.5 5.5 12.5-15 6.5-5.2-0.6-13.6 7.7z",
        label: [312, 363.5],
        bbox: [248, 282.1, 344, 400.5],
    },
    {
        code: "707",
        state: federal_state_1.FederalState.TIROL,
        name: "Lienz",
        d: "M418.2 446l-2.7 15-7.7-0.8-10.3 0.5-16-7.7-6.4-4.5-2.6-10.1-6.2-1.9-2.2-15.4-2.3-3.6-7.2 2-6.4-12.4-3.9-3.5-2.2-9.5 3.4-3.6 7.4-0.4 4.6-8.1 5.6-4.5 7.9-3.2 2.3-6.1 4.7-2.2 8.5 1.6 2.3-2.6 10.7 4.2 3.3 2.2 8.4 4.8 6.9 9.8 5.7 4.5-1.8 10.7 2.4 2.4 3.5 3.3 0.9 2.5 1.9 0.7 1.7 1.1 2.5 10.7 7.1 6.8 1.2 0.6 0.2 0 7.3 4.6-4.1 6.6-4.2-2.4-5.5 3.2-2 2-4-1.3-1.8 0.2-6.2 1.5-4.7 2.3z",
        label: [389.6, 401],
        bbox: [342.1, 365, 450.7, 461],
    },
    {
        code: "702",
        state: federal_state_1.FederalState.TIROL,
        name: "Imst",
        d: "M209.1 397.5l9.6 4.4-1.2 6-5.1 0.5-5.6 14.5 1.4 6.4-6.1 5.5-1.8 5.4-13.4-1.8-4.5 2.3-11.2-5.4-4.2-6 4-11.2-2.7-5.4 6.2-22.3-3.8-7.6-4.4-5.4-3.5-2.1-7.5-9.9 0.5-1.2 0.3-7.8-4.5-5.6-5-0.6-5.2-2.4-3.5-8.9 0.4-0.4 7 4.4 7.3 1.1-5.5-11.7 3.8-0.3 6.9-1.2 1.8-4.9 3.6 0.9 5-4.7 5.9-0.8 0.1 0.1 5.5 9.3 6.7-2.9 1-3.1 8.2-0.1 0.8-5.2 3.2-0.1-3 8.4 0.2 7.8 4.6 1-0.1 2.3 3.7-0.6 1.4 8.6-1.3 1.4 4.6 4-5.3 4-1.4 4.4 2.7 12.9 4.9 9.3 2.2 3.6-3.7 11.1z",
        label: [180, 354.7],
        bbox: [137.9, 319.3, 218.7, 440.7],
    },
    {
        code: "708",
        state: federal_state_1.FederalState.TIROL,
        name: "Reutte",
        d: "M137.9 338.9l3.5 8.9-9.1 1.9-6 1.1-3 7.4-3.8 3.8-2.1-1.6-10.7 3-10.7 1.7-0.2-2.7-1.8-12.5-2.5-6.4 7-0.1 4.3-3.3 10.7-5.7 6.3-11.3 5-0.7 0.3-6.4 4.1-6.7-0.9-6.5-3.6-2.5 2.4-11.5 4.5 2.9 1.1 0.3 3.5 0.7 4.9-0.2 4.5-6.4 10.4 2.6 8 3.4 3 3.6 16.3-3.4-0.4 11 5.9 2.3 6.6 7.3 1 6.5-0.8 5.2-8.2 0.1-1 3.1-6.7 2.9-5.5-9.3-0.1-0.1-5.9 0.8-5 4.7-3.6-0.9-1.8 4.9-6.9 1.2-3.8 0.3 5.5 11.7-7.3-1.1-7-4.4-0.4 0.4zM127.1 288.8l-2.5-5.4 4.5-0.6-2 6z",
        label: [148.3, 310.2],
        bbox: [91.5, 282.8, 196.4, 365.1],
    },
    {
        code: "703",
        state: federal_state_1.FederalState.TIROL,
        name: "Innsbruck-Land",
        d: "M253.6 400.3l-4.3 1.7-5.5-4.8-5-0.4-9.2 3.4-10.9 1.7-9.6-4.4 3.7-11.1-2.2-3.6-4.9-9.3-2.7-12.9 1.4-4.4 5.3-4-4.6-4 1.3-1.4-1.4-8.6-3.7 0.6 0.1-2.3-4.6-1-0.2-7.8 3-8.4 5 0.1 5.9 0.3 13.5-7.6 2.2 7 6.4-0.1 2.4-5.6 5.8-4.1 11 0.7 2.5 6.5 7.7 9.2 7.4 2.2 5.3 0.6 1.6 5.2 1.3 2.4 1.4-0.5 2.5 3.3 5.1 6.2 1.6 10.9-4.7 1.4 0.7 7.2-5.1 3.8 3.3 16.8-1.2 1.1-2.8 6.4-4.8 1.6-6.7 4-7.7-5.1-5.6 7.1zM236.8 344.6l5.2 4.1 5.7 1 0.1 4.7 0.6 0.2 7.6-0.1-2.8-6.6 2.9-2.4-0.2-1.5-4.7-5.2 1.2-5 0.2-4.9-9-2.6-3.4 3.3 0.6 5.6-4 9.4z",
        label: [232.9, 373],
        bbox: [196.6, 309.3, 288.2, 402],
    },
    {
        code: "706",
        state: federal_state_1.FederalState.TIROL,
        name: "Landeck",
        d: "M149 421.3l-6.9 4.2-13-2.4-0.6-5.6 3.1-10.3-4.2-2.6-8.7-9.4-5.2 1.9-6.7 13.5-7.1-2.2-1.3 12.4-11.2 3.1-6-14.7 7.9-10.8-3.2-8.7-0.2-9.3 10.3-15.3 10.7-1.7 10.7-3 2.1 1.6 3.8-3.8 3-7.4 6-1.1 9.1-1.9 5.2 2.4 5 0.6 4.5 5.6-0.3 7.8-0.5 1.2 7.5 9.9 3.5 2.1 4.4 5.4 3.8 7.6-6.2 22.3 2.7 5.4-4 11.2-9-5.7-3.4-4.4-5.6 2.1z",
        label: [139.5, 383.5],
        bbox: [81.2, 347.8, 174.5, 429.3],
    },
    {
        code: "704",
        state: federal_state_1.FederalState.TIROL,
        name: "Kitzbühel",
        d: "M388.2 324.7l2.1 5.9-2.2 2.1-13.3 2.9-5.1-3.3-5 0.1-4.2 5-1.2-1.1-4.6-0.6-7 1.8-6.5-1-4.6 6-9.6 0.8 2.4-9.6 5.1-2.1 2.8-8.1-2-8.8 4.3-2 1-6.5 0.6 0.2 1.9-3.2 2.6-0.9 5.6 3.1 1.4 0.7 1.1-0.5 4.7-2 5.4 0.7 2.4 0.1 1.7-5.5-0.3-12.1-1.3-1.8-0.2-1.2 2-2-0.4-1 2.5-17.8 12.9-1 0.1 4.1 7.5 9.4 3.4-1.1 6.4-0.3-0.1 5.2 10.2 3.3-3.2 7.3 3.3 2.5 1.4 5.9 4.5 5.4-8.7 2.4 0 6.4-1 1.8-5.9 5.8-4.3-1.1-5.1 0.8-3.5 4.9z",
        label: [388.7, 299.3],
        bbox: [327, 262, 416.7, 343.3],
    },
    {
        code: "705",
        state: federal_state_1.FederalState.TIROL,
        name: "Kufstein",
        d: "M329.4 333.7l-12.1-2.7-0.8-5-4.3-3.4-6.5-3.6-0.1-1.9-2.5 1.1-5.9-6.3 0.9-4 6.1-2.9 0.4-2.6 0.3-10.2-10.1-4 2.6-6.1 9.4 1.6 6-5 15.3-2.9 9 2.6 8.6 0.2 3.7 1.5 2.6-7.9-1.5-2.9-0.4-8.3 7.7 1.7 1.8 2.4 9-3.1 1.7 1-2.5 17.8 0.4 1-2 2 0.2 1.2 1.3 1.8 0.3 12.1-1.7 5.5-2.4-0.1-5.4-0.7-4.7 2-1.1 0.5-1.4-0.7-5.6-3.1-2.6 0.9-1.9 3.2-0.6-0.2-1 6.5-4.3 2 2 8.8-2.8 8.1-5.1 2.1z",
        label: [324.7, 295.8],
        bbox: [294.8, 261, 370.3, 333.7],
    },
    {
        code: "701",
        state: federal_state_1.FederalState.TIROL,
        name: "Innsbruck-Stadt",
        d: "M256 354.5l-2.8-6.6 2.9-2.4-0.2-1.5-4.7-5.2 1.2-5 0.2-4.9-9-2.6-3.4 3.3 0.6 5.6-4 9.4 5.2 4.1 5.7 1 0.1 4.7 0.6 0.2 7.6-0.1z",
        label: [245.2, 342.2],
        bbox: [236.8, 326.3, 256.1, 354.6],
    },
    {
        code: "801",
        state: federal_state_1.FederalState.VORARLBERG,
        name: "Bludenz",
        d: "M85.9 389.7l3.2 8.7-7.9 10.8 6 14.7-7.4-2-14.1-10.5-4.1 0.7-9-4.4 1.6-12.6-12.4-5.8-10.9-4.1-4-1.7-9.1 0.1 3.6-7.7-1.8-9.7 4.7-12.3 1.6 1.9 5 2.2 2.1-2.4 2.7-0.4 1.1-1.1 0.3-4.2 3.3-0.8 5.8-2.3 3-2.9 0.3 0 9.9-4 5.4 4 4.2-1.1 4.9 4.1 2.9 4.4 4.7 0.6 4.7-4.8 7.8 2.8 1.8 12.5 0.2 2.7-10.3 15.3 0.2 9.3z",
        label: [58.5, 369.7],
        bbox: [17.8, 339.9, 96, 423.9],
    },
    {
        code: "802",
        state: federal_state_1.FederalState.VORARLBERG,
        name: "Bregenz",
        d: "M86.2 347.1l-4.7 4.8-4.7-0.6-2.9-4.4-4.9-4.1-4.2 1.1-5.4-4-9.9 4-0.3 0-2.4-3.1 1.8-3.5-0.2-11.1-0.7-3.5-4.8-7.1 1.5-4.1-1.5-1.8-2.9 0.5-5.6-0.2-3-0.9-1.8 0.2-2.1-2.7-0.9 0.6-2 1.6-6.7-3.7-1.9 0.9-4-5.9 2.2-2.1 4.9-1.3 3.1-0.8 3.5-0.9 8.3-2 3-7.4 2.6-4 5.7 1 1.3 8.3 5.7 3.1 0.8-3.7 10.9 4.7 4.5 7.7 4.8-1.2 8.6 11.3-3.9 3 3.1 10.5 0.3 1 2.5-4 6.5 0.8 3.3-3.4 5.4 3-8.4 18.1 0.8 1.7 2.5 6.4-7.8-2.8z",
        label: [62.8, 319.7],
        bbox: [12, 281.6, 99.1, 351.9],
    },
    {
        code: "804",
        state: federal_state_1.FederalState.VORARLBERG,
        name: "Feldkirch",
        d: "M19.6 366.2l-6.1-4.6 1.5-5.5-7-12.7 3.7-5.6 3.7-3.4 1.1-3.8 3-4.8 3.8-0.9 2.8 4.5 5.6 1.2 1.1-1.5 1 3.5 6 3.9 7 4.3 2.4 3.1-3 2.9-5.8 2.3-3.3 0.8-0.3 4.2-1.1 1.1-2.7 0.4-2.1 2.4-5-2.2-1.6-1.9-4.7 12.3z",
        label: [26, 342.1],
        bbox: [8, 324.9, 49.2, 366.2],
    },
    {
        code: "803",
        state: federal_state_1.FederalState.VORARLBERG,
        name: "Dornbirn",
        d: "M32.8 329.1l-1.1 1.5-5.6-1.2-2.8-4.5 3.1-4.6-2.8-3.4 1-8.1 2-1.6 0.9-0.6 2.1 2.7 1.8-0.2 3 0.9 5.6 0.2 2.9-0.5 1.5 1.8-1.5 4.1 4.8 7.1 0.7 3.5 0.2 11.1-1.8 3.5-7-4.3-6-3.9-1-3.5z",
        label: [35.4, 320.1],
        bbox: [23.3, 306.6, 48.6, 340.8],
    },
    {
        code: "922",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 22., Donaustadt",
        d: "M916.7 175.9l-5.2-6.2 2.1-11.9-0.7-4.6-4.2-4.3-1.6-1-3.6 2.9-9.8 7.5 12.7 13.4 2.2 1.5 8 4.5 0.1-1.8z",
        label: [905.2, 159.1],
        bbox: [893.7, 147.9, 916.7, 177.7],
    },
    {
        code: "921",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 21., Floridsdorf",
        d: "M893.7 158.3l9.8-7.5-6-8.6-4.2-0.4-4.1 7.7-1-0.2 2.1 4 3.4 5z",
        label: [895.5, 149.7],
        bbox: [888.2, 141.8, 903.5, 158.3],
    },
    {
        code: "914",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 14., Penzing",
        d: "M869.1 164.8l13.7 2.9-0.4-3-7.4-3.5 0.4-3.6-6.3-4.6-2.9 7.8 2.9 4z",
        label: [871, 159.7],
        bbox: [866.2, 153, 882.8, 167.7],
    },
    {
        code: "902",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 2., Leopoldstadt",
        d: "M891.9 163.1l6 4.8 8.5 3.8-12.7-13.4-4 2.2 0.4 1.2 1.8 1.4z",
        label: [893.5, 161.4],
        bbox: [889.7, 158.3, 906.4, 171.7],
    },
    {
        code: "910",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 10., Favoriten",
        d: "M898.7 180.6l-0.1-3.4-5.3-7.2-1.9-2.4-1.5 0.8-2.5 0.9-1.8 3.8 3.9 5.8 0 0.1 2.9 0.6 3.1 1.4 3.2-0.4z",
        label: [891.3, 174.3],
        bbox: [885.6, 167.6, 898.7, 181],
    },
    {
        code: "913",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 13., Hietzing",
        d: "M879.9 172.5l3.7-4.5-0.8-0.3-13.7-2.9-3.3 6 2 3.2 3.3 0.2 8.8-1.7z",
        label: [871.4, 169.7],
        bbox: [865.8, 164.8, 883.6, 174.2],
    },
    {
        code: "923",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 23., Liesing",
        d: "M870.4 179.1l1 0.5 0.5-0.3 8.9 0.3 1.8 1.1 6.9-1.8-3.9-5.8-5.7-0.6-8.8 1.7-0.7 4.9z",
        label: [883.1, 176.6],
        bbox: [870.4, 172.5, 889.5, 180.7],
    },
    {
        code: "911",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 11., Simmering",
        d: "M898.6 177.2l10-4-2.2-1.5-8.5-3.8-4.6 2.1 5.3 7.2z",
        label: [900, 172.7],
        bbox: [893.3, 167.9, 908.6, 177.2],
    },
    {
        code: "919",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 19., Döbling",
        d: "M879.5 155.5l8.4 3.6 1-0.8 1.4-5-2.1-4-9.1 4.8 0.4 1.4z",
        label: [886.1, 154.4],
        bbox: [879.1, 149.3, 890.3, 159.1],
    },
    {
        code: "917",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 17., Hernals",
        d: "M886.3 162.4l0.1-0.4-6.9-6.5-0.4-1.4-3.7 3.5-0.4 3.6 11.1 1.8 0.2-0.6z",
        label: [878.6, 158.7],
        bbox: [875, 154.1, 886.4, 163],
    },
    {
        code: "918",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 18., Währing",
        d: "M886.4 162l1.5-2.9-8.4-3.6 6.9 6.5z",
        label: [886, 159.7],
        bbox: [879.5, 155.5, 887.9, 162],
    },
    {
        code: "903",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 3., Landstraße",
        d: "M893.3 170l4.6-2.1-6-4.8-1.2 2.2 0.7 2.3 1.9 2.4z",
        label: [894, 167.4],
        bbox: [890.7, 163.1, 897.9, 170],
    },
    {
        code: "912",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 12., Meidling",
        d: "M885.6 173.1l1.8-3.8-1-1.8-0.4 0-2.4 0.5-3.7 4.5 5.7 0.6z",
        label: [884.3, 170.7],
        bbox: [879.9, 167.5, 887.4, 173.1],
    },
    {
        code: "916",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 16., Ottakring",
        d: "M875 161.2l7.4 3.5 3.4-0.2 0.2-0.9 0.1-0.6-11.1-1.8z",
        label: [882.6, 163.5],
        bbox: [875, 161.2, 886.1, 164.7],
    },
    {
        code: "920",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 20., Brigittenau",
        d: "M889.7 160.5l4-2.2-3.4-5-1.4 5 0.8 2.2z",
        label: [891, 157.7],
        bbox: [888.9, 153.3, 893.7, 160.5],
    },
    {
        code: "909",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 9., Alsergrund",
        d: "M886.3 162.4l2 0.1 1.8-0.8-0.4-1.2-0.8-2.2-1 0.8-1.5 2.9-0.1 0.4z",
        label: [888.4, 160.9],
        bbox: [886.3, 158.3, 890.1, 162.5],
    },
    {
        code: "901",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 1., Innere Stadt",
        d: "M889.5 165.3l1.2 0 1.2-2.2-1.8-1.4-1.8 0.8-0.1 1.5 0.7 0.8 0.6 0.5z",
        label: [889.9, 163.5],
        bbox: [888.2, 161.7, 891.9, 165.3],
    },
    {
        code: "915",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 15., Rudolfsheim-Fünfhaus",
        d: "M883.6 168l2.4-0.5 0.1-1.4-0.3-1.6-3.4 0.2 0.4 3 0.8 0.3z",
        label: [884.5, 166.2],
        bbox: [882.4, 164.5, 886.1, 168],
    },
    {
        code: "905",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 5., Margareten",
        d: "M887.4 169.3l2.5-0.9-1.2-2.5-2.3 1.6 1 1.8z",
        label: [888.2, 167.7],
        bbox: [886.4, 165.9, 889.9, 169.3],
    },
    {
        code: "906",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 6., Mariahilf",
        d: "M886.4 167.5l2.3-1.6 0.8-0.6-0.6-0.5-2.8 1.3-0.1 1.4 0.4 0z",
        label: [886.7, 166.5],
        bbox: [886, 164.8, 889.5, 167.5],
    },
    {
        code: "904",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 4., Wieden",
        d: "M889.9 168.4l1.5-0.8-0.7-2.3-1.2 0-0.8 0.6 1.2 2.5z",
        label: [890, 166.3],
        bbox: [888.7, 165.3, 891.4, 168.4],
    },
    {
        code: "907",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 7., Neubau",
        d: "M886.1 166.1l2.8-1.3-0.7-0.8-2.2-0.4-0.2 0.9 0.3 1.6z",
        label: [886.8, 164.7],
        bbox: [885.8, 163.6, 888.9, 166.1],
    },
    {
        code: "908",
        state: federal_state_1.FederalState.WIEN,
        name: "Wien 8., Josefstadt",
        d: "M886 163.6l2.2 0.4 0.1-1.5-2-0.1-0.2 0.6-0.1 0.6z",
        label: [887.5, 163.2],
        bbox: [886, 162.4, 888.3, 164],
    },
];
/** Bounding box of each Bundesland (drill-down viewBox). */
exports.AUSTRIA_STATE_BBOX = {
    [federal_state_1.FederalState.BURGENLAND]: [841.8, 180.9, 992, 426.8],
    [federal_state_1.FederalState.KAERNTEN]: [411.2, 370.2, 721.7, 508.1],
    [federal_state_1.FederalState.NIEDEROESTERREICH]: [643.2, 8, 979.9, 314.3],
    [federal_state_1.FederalState.OBEROESTERREICH]: [423.3, 56.8, 712.3, 306.7],
    [federal_state_1.FederalState.SALZBURG]: [336.6, 196.4, 583.5, 406.1],
    [federal_state_1.FederalState.STEIERMARK]: [528.2, 237, 864.5, 469.7],
    [federal_state_1.FederalState.TIROL]: [81.2, 261, 450.7, 461],
    [federal_state_1.FederalState.VORARLBERG]: [8, 281.6, 99.1, 423.9],
    [federal_state_1.FederalState.WIEN]: [865.8, 141.8, 916.7, 181],
};
